import React from 'react';
import { FAQS } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

export default function FAQ() {
  return (
    <section id="faq" className="relative py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="section-title-eyebrow uppercase">FAQ</div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
            <span className="text-white">વારંવાર </span><span className="gradient-text">પૂછાતા પ્રશ્નો</span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="card-dark px-5">
              <AccordionTrigger className="text-left text-white text-[15px] font-semibold hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-gray-300 text-sm leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
